import React, { useEffect } from 'react';
import Gray from '../../../../resources/images/minus-circle.svg';
import Pass from '../../../../resources/images/checkmark-circle20.svg';
import Error from '../../../../resources/images/close-circle20.svg';
import Password from '../../atoms/password/Password';
import { isPasswordContainsEmail } from '../../utils/commonUtils';
import { logError } from '../../utils/logger';
import './passwordRules.scss';

const PasswordRules = props => {
    const {
        email,
        passwordDisclaimer,
        passwordFieldLabel,
        passwordRules = [],
        firstName,
        lastName,
        password,
        errorPassword,
        handleInputChange,
        setValidPassword,
        isFormSubmit,
        onFocus = () => {},
        required = false
    } = props;
    const hasCapitalLetter = /[A-Z]/.test(password);
    const hasLowerCaseCharacter = /[a-z]/.test(password);
    const hasMinimumLength = password.length >= 8;
    const hasDigit = /\d/.test(password);
    const notSpaces = password.trim() != '' && !/\s/.test(password);
    const notNameAndEmail =
        password.trim() != '' &&
        !password.toLowerCase().includes(firstName?.toLowerCase()) &&
        !password.toLowerCase().includes(lastName?.toLowerCase()) &&
        !isPasswordContainsEmail(email, password.toLowerCase());

    const isValidPassword = () => {
        try {
            return (
                hasCapitalLetter &&
                hasLowerCaseCharacter &&
                hasMinimumLength &&
                hasDigit &&
                notSpaces &&
                notNameAndEmail
            );
        } catch (error) {
            logError(error, true, 'isValidPassword', {});
        }
    };

    useEffect(() => {
        setValidPassword(isValidPassword);
    }, [hasCapitalLetter, hasLowerCaseCharacter, hasMinimumLength, hasDigit, notSpaces, notNameAndEmail]);

    const checkFormSubmit = () => {
        return isFormSubmit ? <Error tabIndex="-1" aria-hidden={true} /> : <Gray tabIndex="-1" aria-hidden={true} />;
    };

    const rulePass = () => {
        return <Pass tabIndex="-1" aria-hidden={true} />;
    };

    const isNamesEntered = () => {
        return firstName.trim() !== '' && lastName.trim() !== '';
    };

    const checkNameRule = () => {
        return isNamesEntered() ? checkFormSubmit() : <Gray tabIndex="-1" aria-hidden={true} />;
    };

    return (
        <>
            <div>
                <div>
                    <p tabIndex="0" className="password_form_subtitle">
                        {passwordDisclaimer}
                    </p>

                    <ul className="password-rules-list">
                        <li role="checkbox" aria-checked={hasCapitalLetter} tabIndex="0">
                            {hasCapitalLetter ? rulePass() : checkFormSubmit()}
                            <div className="password-rules-label">{passwordRules[0]}</div>
                        </li>
                        <li role="checkbox" aria-checked={hasLowerCaseCharacter} tabIndex="0">
                            {hasLowerCaseCharacter ? rulePass() : checkFormSubmit()}
                            <div className="password-rules-label">{passwordRules[1]}</div>
                        </li>
                        <li role="checkbox" aria-checked={hasDigit} tabIndex="0">
                            {hasDigit ? rulePass() : checkFormSubmit()}
                            <div className="password-rules-label">{passwordRules[2]}</div>
                        </li>
                        <li role="checkbox" aria-checked={hasMinimumLength} tabIndex="0">
                            {hasMinimumLength ? rulePass() : checkFormSubmit()}
                            <div className="password-rules-label">{passwordRules[3]}</div>
                        </li>
                        <li role="checkbox" aria-checked={notNameAndEmail} tabIndex="0">
                            {notNameAndEmail ? rulePass() : checkNameRule()}
                            <div className="password-rules-label">{passwordRules[4]}</div>
                        </li>
                        <li role="checkbox" aria-checked={notSpaces} tabIndex="0">
                            {notSpaces ? rulePass() : checkFormSubmit()}
                            <div className="password-rules-label">{passwordRules[5]}</div>
                        </li>
                    </ul>
                </div>

                <div>
                    <Password
                        name="password"
                        label={passwordFieldLabel}
                        value={password}
                        handleInputChange={handleInputChange}
                        dataTestId={'personal_info_password'}
                        errorMsg={errorPassword}
                        maxLength={128}
                        onFocus={onFocus}
                        required={required}
                    />
                </div>
            </div>
        </>
    );
};

export default PasswordRules;
